import { WorkflowConstants } from 'constants/workflowConstants';
import { createAction } from 'redux-actions';

export const checkinAction = createAction(WorkflowConstants.CHECKIN_ACTION);
export const nextAction = createAction(WorkflowConstants.NEXT_ACTION);
export const checkPreviousAction = createAction(WorkflowConstants.PREVIOUS_ACTION);
export const getBankAccountDetails = createAction(WorkflowConstants.GET_BANK_DETAILS);
export const getIPAddress = createAction(WorkflowConstants.GET_IP_ADDRESS);
export const getKeyAction = createAction(WorkflowConstants.GET_KEY_ACTION);
export const getTestValuesData = createAction(WorkflowConstants.GET_TEST_VALUES_DATA);
export const resumeApplicationAction = createAction(WorkflowConstants.RESUME_APPLICATION);
export const getAutopayDraftsAction = createAction(WorkflowConstants.GET_AUTOPAY_DRAFTS);
